export const LOCALES_WITH_TRANSLATIONS = [
  { value: 'en', nativeName: 'English' },
  { value: 'es', nativeName: 'Español' },
  { value: 'ru', nativeName: 'Русский' },
  { value: 'fa', nativeName: 'فارسی' },
  { value: 'ar', nativeName: 'العربية' },
  { value: 'pt', nativeName: 'Português' },
  { value: 'cs', nativeName: 'Čeština' },
  { value: 'tr', nativeName: 'Türkçe' },
  { value: 'de', nativeName: 'German' },
  { value: 'fr', nativeName: 'Français' },
  { value: 'cn', nativeName: '中文' },
  { value: 'hu', nativeName: 'Magyar' },
  { value: 'id', nativeName: 'Bahasa Indonesia' },
  { value: 'jp', nativeName: '日本語' },
  { value: 'kr', nativeName: '한국어' },
  { value: 'pl', nativeName: 'Polski' },
  { value: 'rs', nativeName: 'Српски' },
  { value: 'vn', nativeName: 'Tiếng Việt' },
  // { value: 'zh', nativeName: '中文' },
] as const;

export const locales = LOCALES_WITH_TRANSLATIONS.map(({ value }) => value);

export const localePrefix = 'always'; // Default

export const defaultLocale = 'en';
